/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';
import Owl from '../vendors/owl.carousel.min';
import Chart from '../vendors/chart';

jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );

/**
 * Document Ready Function
 * Triggered when document get's ready
 */

jQuery( function() {


	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}

	// accessible sub menu
	jQuery( '.menu-item-has-children > a' )
		.focus( function() {
			jQuery( this ).siblings( '.sub-menu' ).addClass( 'focused' );
		} )
		.blur( function() {
			jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
		} );

	jQuery( '.menu-btn' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );
	jQuery.noConflict();

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */
	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon"></span>' );
		}
	} );

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

	jQuery( document ).on( 'click', '.header-nav .menu-item span', function() {
		const link = jQuery( this ).parents( 'li' );

		link.siblings( '.active' ).removeClass( 'active' ).find( 'ul' ).slideUp();

		if ( link.hasClass( 'active' ) ) {
			link.removeClass( 'active' );
			link.parents( 'ul' ).removeClass( 'disabled-menu' );
			link.find( 'ul' ).slideUp();
		} else {
			link.addClass( 'active' );
			link.parents( 'ul' ).addClass( 'disabled-menu' );
			link.find( 'ul' ).slideDown();
		}
	} );


	if(jQuery('.doughnut-chart').length > 0 ) {

		jQuery( '.doughnut-chart' ).each( function() {
			const chartElement = this;
			const colors = JSON.parse( jQuery( this ).attr( 'data-colors' ) );
			const values = JSON.parse( jQuery( this ).attr( 'data-values' ) );

			if ( chartElement ) {
				chartElement.width = 400;
				chartElement.height = 400;

				const ctx = chartElement.getContext( '2d' );
				new Chart( ctx, {
					type: 'doughnut',
					data: {
						datasets: [ {
							data: values,
							backgroundColor: colors,
						} ],
					},
					options: {
						tooltips: {
							enabled: false,
						},
					},
				} );
			}
		} );
	}

	/**
	 *
	 * Sector dropdown
	 *
	 */

	jQuery( '.js-books-slider' ).slick( {
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		dots: false,
		arrows: true,
		touchThreshold: 200,
		responsive: [
			{
				breakpoint: 747, // Screen width 747px and below
				settings: {
					slidesToShow: 2, // Show 2 slides
					slidesToScroll: 2, // Scroll 2 slides
				},
			},
			{
				breakpoint: 374, // Screen width 747px and below
				settings: {
					slidesToShow: 1, // Show 2 slides
					slidesToScroll: 1, // Scroll 2 slides
				},
			},
		],
	} );

	if ( jQuery( '.tab-ctn' ).length > 0 ) {
		jQuery( '.tab-content' ).eq( 0 ).addClass( 'current' );
		jQuery( 'button.tab-button' ).on( 'click', function() {
			const tabId = jQuery( this ).attr( 'href' );
			const containerWrap = jQuery( this ).closest( '.tab-ctn' );
			containerWrap.find( '.tab-content' ).hide();
			containerWrap.find( `${ tabId }` ).fadeIn( 800 ).addClass( 'current' );
			containerWrap.find( '.tab-button' ).removeClass( 'current' );
			jQuery( this ).addClass( 'current' );
		} );
	}

	if ( jQuery( '.header-search-button' ).length > 0 ) {
		jQuery( '.header-search-button' ).on( 'click', function() {
			jQuery( '.header-search-form' ).addClass( 'show' );
		} );
		jQuery( '.header-search-close' ).on( 'click', function() {
			jQuery( '.header-search-form' ).removeClass( 'show' );
			jQuery( 'input.header-serach-mobile-input' ).val( '' );
		} );
	}

	if ( jQuery( '.stats-ctn' ).length > 0 && window.innerWidth > 1003 ) {
		let maxHeight = 0;
		jQuery( '.stats-desc' ).each( function() {
			const thisHeight = jQuery( this ).outerHeight();
			if ( thisHeight > maxHeight ) {
				maxHeight = thisHeight;
			}
		} );
		jQuery( '.stats-ctn' ).find( '.stats-desc' ).css( 'height', maxHeight );
	}

	if ( jQuery( '.pdf-book-item .wp-block-heading' ).length > 0 ) {
		let maxHeightPdfHeight = 0;
		jQuery( '.pdf-book-item .wp-block-heading' ).each( function() {
			const parentCtnPdfHeading =
				jQuery( this ).closest( '.js-books-slider' );
			const thisHeight = jQuery( this ).outerHeight();
			if ( thisHeight > maxHeightPdfHeight ) {
				maxHeightPdfHeight = thisHeight;
			}
			jQuery( parentCtnPdfHeading )
				.find( '.pdf-book-item .wp-block-heading' )
				.css( 'height', maxHeightPdfHeight );
		} );
	}
	if ( jQuery( '.js-timeline-content-slider' ).length > 0 ) {
		jQuery( '.timeline-slide' ).each( function() {
			jQuery( this )
				.find( '.iat-content-inner .wp-block-heading' )
				.prev( 'p:first' )
				.addClass( 'timeline-year-small' );
		} );

		const newTimelineYearsSlider = jQuery(
			'<div class="timeline-years-slider js-timeline-years-slider"></div>',
		);

		jQuery( '.js-timeline-content-slider .timeline-slide' ).each(
			function( index ) {
				const heading = jQuery( this ).find( '.wp-block-heading' ).text();
				const year = jQuery( this ).find( '.timeline-year-small' ).text();

				const yearBlock = `
			    <div class="timeline-year">
			      <div class="year-title">${ year }</div>
			      <div class="description">${ heading }</div>
			    </div>
			  `;

				newTimelineYearsSlider.append( yearBlock );
			},
		);

		jQuery( '.timeline-content-slider' ).after( newTimelineYearsSlider );

		jQuery( '.js-timeline-content-slider' ).slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			asNavFor: '.js-timeline-years-slider',
			touchThreshold: 200,
			infinite: true,
			draggable: false,
		} );

		jQuery( '.js-timeline-years-slider' ).slick( {
			slidesToShow: 4,
			slidesToScroll: 1,
			asNavFor: '.js-timeline-content-slider',
			// centerMode: true,
			// centerPadding: 0,
			focusOnSelect: true,
			touchThreshold: 200,
			dots: false,
			infinite: true,
			arrows: true,
			responsive: [
				{
					breakpoint: 1003,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					},
				},
				{
					breakpoint: 747,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		} );
	}

	if ( jQuery( '.stats-number' ).length > 0 ) {
		const $statNumbers = jQuery( '.stats-number' );

		function animateCounter( jQueryElement ) {
			const text = jQueryElement.text();
			// Extract numeric part for calculation
			const numericText = text.replace( /[^0-9.]/g, '' );

			if ( isNaN( numericText ) || numericText === '' ) {
				return; // Skip if no valid number is found
			}

			const currentValue = parseFloat( numericText );
			const startValue = currentValue * 0.9; // 10% less than current value
			const targetValue = currentValue; // Final value to display

			// Determine if the final value should have floating points
			const hasDecimal = targetValue % 1 !== 0;

			const duration = 2000;
			const frameDuration = 1000 / 60;
			const totalFrames = duration / frameDuration;
			const increment = ( targetValue - startValue ) / totalFrames;
			let animatedValue = startValue;

			function formatValue( value ) {
				// Display floating-point if necessary, otherwise show integer
				return hasDecimal ? value.toFixed( 2 ) : value.toFixed( 0 );
			}

			function updateCounter() {
				animatedValue += increment;
				if ( animatedValue >= targetValue ) {
					jQueryElement.text(
						`${ text.replace(
							numericText,
							formatValue( targetValue ),
						) }`,
					);
				} else {
					// Replace only the numeric part while keeping the symbols
					const newText = text.replace(
						numericText,
						formatValue( animatedValue ),
					);
					jQueryElement.text( newText );
					requestAnimationFrame( updateCounter );
				}
			}

			requestAnimationFrame( updateCounter );
		}

		function isInViewport( element ) {
			const rect = element[ 0 ].getBoundingClientRect();
			return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <=
					( window.innerHeight ||
						document.documentElement.clientHeight ) &&
				rect.right <=
					( window.innerWidth || document.documentElement.clientWidth )
			);
		}

		jQuery( window )
			.on( 'scroll', function() {
				$statNumbers.each( function() {
					const jQueryThis = jQuery( this );
					if (
						isInViewport( jQueryThis ) &&
						! jQueryThis.hasClass( 'animated' )
					) {
						animateCounter( jQueryThis );
						jQueryThis.addClass( 'animated' );
					}
				} );
			} )
			.trigger( 'scroll' );
	}

	if ( jQuery( '.scroll-to-top' ).length > 0 ) {
		const scrollToTopButton = jQuery( '.scroll-to-top' );

		jQuery( window ).scroll( function() {
			if ( jQuery( window ).scrollTop() > 300 ) {
				scrollToTopButton.addClass( 'show' );
			} else {
				scrollToTopButton.removeClass( 'show' );
			}
		} );

		scrollToTopButton.on( 'click', function( e ) {
			e.preventDefault();
			jQuery( 'html, body' ).animate( { scrollTop: 0 }, '300' );
		} );

		const svg = document.querySelector( '.footer-top-button' );
		const footer = document.querySelector( 'footer' );

		const observer = new IntersectionObserver(
			( entries ) => {
				entries.forEach( ( entry ) => {
					if ( entry.isIntersecting ) {
						svg.classList.add( 'white' );
					} else {
						svg.classList.remove( 'white' );
					}
				} );
			},
			{
				rootMargin: '0px 0px -65px 0px',
			},
		);

		observer.observe( footer );
	}
} );




